<script>
	import StLogo from '../st-logo.svelte'
	import { activeSlideIndex, tooTallSlides } from '../stores'

	export let fields
	let { hips, knees } = fields

	let activeSide = 0

	let containerWidth
	let slidingWrapWidth

	let sideOneHeight = 0
	let sideTwoHeight = 0

	$: previewWidth = slidingWrapWidth - ($tooTallSlides ? 510 : 590)

	$: showLogo = $activeSlideIndex === 1 || $tooTallSlides

	$: fillerHeight =
		Math.max(sideOneHeight, sideTwoHeight) -
		Math.min(sideOneHeight, sideTwoHeight)
</script>

{#if showLogo}
	<StLogo disableMovement={$tooTallSlides} />
{/if}

<div class="widthgetter" bind:clientWidth={containerWidth} />

<div class="sliding-wrap" class:active-two={activeSide === 1}>

	<div
		class="sliding-wrap-left"
		on:click={() => (activeSide = 0)}
		class:active={activeSide === 0}
		bind:clientWidth={slidingWrapWidth}>
		<div class="sliding-wrap-content">
			<h2>
				<em>Specializing in</em>
				Hips &
			</h2>
			<div class="swc-inner" bind:clientHeight={sideOneHeight}>
				<div class="sc-title">
					<div>
						<div style="background-image:url({hips.image})" />
					</div>
					<h3>
						{@html hips.headline}
					</h3>
				</div>
				{@html hips.content}
				<div class="sc-tags">
					{#each hips.bullets as bullet}
						<span>{bullet['point']}</span>
					{/each}
				</div>
				<a href={hips.link} class="pointer-link">Learn More</a>
			</div>
			{#if sideOneHeight < sideTwoHeight}
				<div class="slide-filler" style="height: {fillerHeight}px" />
			{/if}
		</div>
		<div class="sliding-wrap-blue">
			<div
				class="st-logo-holder"
				style="width: {containerWidth}px; right: -{previewWidth}px">
				{#if showLogo}
					<StLogo disableMovement={$tooTallSlides} />
				{/if}
			</div>
			<div class="sliding-wrap-blue-inner" style="width:{slidingWrapWidth}px">
				<div class="sliding-wrap-content">
					<h2>
						<em>Specializing in</em>
						<span>
							Hips &
							<i />
						</span>
					</h2>
					<div class="swc-inner">
						<div class="sc-title">
							<div>
								<div style="background-image:url({hips.image})" />
							</div>
							<h3>
								{@html hips.headline}
							</h3>
						</div>
						<p>
							{@html hips.content}
						</p>
						<div class="sc-tags">
							{#each hips.bullets as bullet}
								<span>{bullet['point']}</span>
							{/each}
						</div>
						<a href={hips.link} class="pointer-link">Learn More</a>
					</div>
					{#if sideOneHeight < sideTwoHeight}
						<div style="height: {fillerHeight}px" />
					{/if}
				</div>
			</div>
		</div>
		<!-- <div class="blue-mask" /> -->
	</div>

	<div
		class="sliding-wrap-right"
		on:click={() => (activeSide = 1)}
		class:active={activeSide === 1}>
		<div class="sliding-wrap-content">
			<h2>
				<em>Specializing in</em>
				Knees
			</h2>
			<div class="swc-inner" bind:clientHeight={sideTwoHeight}>
				<div class="sc-title">
					<div>
						<div style="background-image:url({knees.image})" />
					</div>
					<h3>
						{@html knees.headline}
					</h3>
				</div>
				{@html knees.content}
				<div class="sc-tags">
					{#each knees.bullets as bullet}
						<span>{bullet['point']}</span>
					{/each}
				</div>
				<a href={knees.link} class="pointer-link">Learn More</a>
			</div>
			{#if sideOneHeight > sideTwoHeight}
				<div style="height: {fillerHeight}px" />
			{/if}
		</div>
		<div class="sliding-wrap-blue">
			<div
				class="st-logo-holder"
				style="width: {containerWidth}px; left: -{previewWidth}px">
				{#if showLogo}
					<StLogo disableMovement={$tooTallSlides} />
				{/if}
			</div>
			<div class="sliding-wrap-blue-inner" style="width:{slidingWrapWidth}px">
				<div class="sliding-wrap-content">
					<h2>
						<em>Specializing in</em>
						<span>
							Knees
							<i />
						</span>
					</h2>
					<div class="swc-inner">
						<div class="sc-title">
							<div>
								<div style="background-image:url({knees.image}" />
							</div>
							<h3>
								{@html knees.headline}
							</h3>
						</div>
						{@html knees.content}
						<div class="sc-tags">
							{#each knees.bullets as bullet}
								<span>{bullet['point']}</span>
							{/each}
						</div>
						<a href={knees.link} class="pointer-link">Learn More</a>
					</div>
					{#if sideOneHeight > sideTwoHeight}
						<div style="height: {fillerHeight}px" />
					{/if}
				</div>
			</div>
		</div>
	</div>

</div>
